import script from "./FrmRepairPartsIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./FrmRepairPartsIndex.vue?vue&type=script&setup=true&lang=js"

import "./FrmRepairPartsIndex.vue?vue&type=style&index=0&id=f2cce630&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f2cce630"]])

export default __exports__